import CaseDetailModal from 'components/appointment/caseDetailModal';
import { hearingTypeLabel } from 'helpers/legacyHearingType';
import React from 'react'

const CasesTable = ({ cases, onRefresh }) => {
    const [caseDetailModal, setCaseDetailModal] = React.useState(false);
    // const formattedDate = moment(timeZone).format('MMMM DD YYYY, hh:mm A');
    const renderTableHeader = React.useCallback(() => {

        return (
            <tr>
                <th>
                    #
                </th>
                <th>
                    Case Number
                </th>
                <th>
                    Name
                </th>
                <th>
                    Party Type
                </th>
                 <th>
                    Case Type
                </th>
                <th>
                    Service Type
                </th>
                <th>
                    Hearing Type
                </th>
                <th>
                    Hearing Time
                </th>
                <th>
                    Courtroom
                </th>
                <th>
                    Jurisdiction
                </th>
                <th>
                    Case Notes
                </th>
                <th>
                    Translated
                </th>
                <th>
                    Action
                </th>
            </tr>
        )
    }, [])

    const handleCaseDetalOpen = (val) =>{
        setCaseDetailModal({
            open: true,
            data: val
        })
    }

    const handleCaseDetalClose = () =>{
        setCaseDetailModal({
            open: false,
            data: [],
        })
    }

    const renderTableContent = React.useCallback((item, index) => {
        return (
            <CaseItem item={item} key={item?.id} serial={index + 1} handleCaseDetalOpen={handleCaseDetalOpen}/>
        )
    }, []);

    return (
        <div className='table_responsive'>
            <table className="table">
                <thead className="text-primary">
                    {renderTableHeader()}
                </thead>
                <tbody>
                    {
                        cases && [...cases].sort((a, b) => {
                            if (!a.hearing_start_time) return 1;
                            if (!b.hearing_start_time) return -1;
                            return a.hearing_start_time.localeCompare(b.hearing_start_time);
                        }).map((item, index) => renderTableContent(item, index))
                    }
                </tbody>
            </table>

            <CaseDetailModal onClose={handleCaseDetalClose} modalData={caseDetailModal} onRefresh={onRefresh} />
        </div>
    )
}

const formatTime = (timeString) => {
    if (!timeString) return '-';
    const [hours, minutes] = timeString.split(':');
    let hourNum = parseInt(hours);
    const ampm = hourNum >= 12 ? 'PM' : 'AM';
    hourNum = hourNum % 12 || 12;
    return `${hourNum.toString().padStart(2, '0')}:${minutes} ${ampm}`;
};

const CaseItem = ({ item, serial ,handleCaseDetalOpen}) => {

    return (

        <tr>
            <td>
                {serial}
            </td>
            <td>
                {item.case_number || 'N/A'}
            </td>
            <td>
                {item.client_name || 'N/A'}
            </td>
            <td>
                {item.party_type?.name}
            </td>
            <td>
                {item.case_type?.name}
            </td>
            <td>
                {item.service_type || '-'}
            </td>
            <td>
                {item.service_type === 'Document Translation' ? '-' : hearingTypeLabel(item, { tag: false })}
            </td>
            <td>
                {item.service_type === 'Document Translation' ? '-' : formatTime(item.hearing_start_time)}
            </td>
            <td>
                {item.courtroom?.name || '-'}
            </td>
            <td>
                {item.jurisdiction?.name || '-'}
            </td>
            <td>
                {item.notes || '-'}
            </td>
            <td>
                {item.service_type === 'Document Translation' && (
                    item.translated_document
                        ? <span style={{ background: '#22c55e', color: '#fff', padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: 600 }}>Uploaded</span>
                        : <span style={{ background: '#ef4444', color: '#fff', padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: 600 }}>Pending</span>
                )}
            </td>
            <td>
                <button className="table_edit ms-2" onClick={() => handleCaseDetalOpen(item)}>Details</button>
            </td>
        </tr>
    )
}
export default CasesTable